<script lang="ts">
  import { cn } from '$lib/utils';
  import Accordion from '$components/accordion.svelte';
  import RichText from '$components/rich-text.svelte';
  import Icon, { isIconVariant } from '$components/ui/icon/icon.svelte';

  import type { FaqSectionStoryblok } from '$types/bloks';

  export let block: FaqSectionStoryblok;

  const groupId = Math.random().toString(8).substring(2, 9);
</script>

<section
  class={cn(
    'px-2 lg:px-0 py-8',
    block.hide_mobile && 'hidden lg:block',
    block.hide_desktop && 'lg:hidden'
  )}
>
  <div class={cn('container px-2 lg:px-8 2xl:px-0 gap-4 mx-auto')}>
    {#if block.title}
      <h2 class={cn('text-2xl font-medium mb-8')}>
        {block.title}
      </h2>
    {/if}

    {#if !!block.faqs?.length}
      <!-- Mobile -->
      <div class="flex-col gap-2 flex lg:hidden">
        {#each block.faqs as faqItem}
          {#if faqItem.component === 'faq-item'}
            {@const icon = faqItem.icon?.toString()}

            <Accordion
              title={faqItem.title}
              as="h2"
              variant="product"
              group={groupId}
              icon={icon && isIconVariant(icon) ? icon : undefined}
            >
              <RichText
                doc={faqItem.content}
                class={cn(
                  '[&>p]:text-sm',
                  '[&>*+p]:mt-1',
                  '[&>p>img]:mt-3 [&>p>img]:w-full [&>p>img]:rounded-xs [&>p>img]:border [&>p>img]:border-primary/4 [&>p>img]:object-contain',
                  '[&>*+.rich-text-button-cta]:mt-3',
                  '[&>*+.rich-text-metrics]:mt-5',
                  '[&>.rich-text-metrics+p]:mt-5'
                )}
              />
            </Accordion>
          {/if}
        {/each}
      </div>

      <!-- Desktop -->
      <div class="hidden lg:grid grid-cols-3 gap-4">
        {#each block.faqs as faqItem}
          {@const icon = faqItem.icon?.toString()}
          {#if faqItem.component === 'faq-item'}
            <div class="bg-primary/2 rounded-sm p-3 border border-primary/4">
              <p class="mb-6 text-sm font-medium flex items-center gap-2 text-left">
                {#if icon && isIconVariant(icon)}
                  <Icon {icon} size="md" />
                {/if}
                <span>{faqItem.title}</span>
              </p>
              <RichText
                doc={faqItem.content}
                class={cn(
                  '[&>p]:text-sm',
                  '[&>*+p]:mt-1',
                  '[&>p>img]:mt-3 [&>p>img]:w-full [&>p>img]:rounded-xs [&>p>img]:border [&>p>img]:border-primary/4 [&>p>img]:object-contain',
                  '[&>*+.rich-text-button-cta]:mt-3',
                  '[&>*+.rich-text-metrics]:mt-5',
                  '[&>.rich-text-metrics+p]:mt-5'
                )}
              />
            </div>
          {/if}
        {/each}
      </div>
    {/if}
  </div>
</section>
